<template>
  <div>
    <b-modal
      id="modal-logout"
      centered
      title="Confirm Exit"
      ok
      ok-variant="success"
      @cancel="hide2nd()"
      cancel-variant="danger"
      @ok="loggingOut()"
    >
      <template v-slot:modal-ok> Yes, Logout </template>
      <p>Are You sure you want to Logout?</p>
    </b-modal>

    <div :class="navbody" class="dashbody p-2 pl-3">
      <div
        style="background: white; width: inherit"
        class="logo-wrapper"
        :to="{ name: 'landing' }"
      >
        <img
          :src="$store.state.loginmaster.details.org_details.logo"
          class="dash-logo"
        />
        <p class="mt-3" style="font-size:18px; overflow-x: clip">
          {{ $store.state.loginmaster.details.clearance_organization }}
        </p>
      </div>

      <b-link
        class="dashlink mt-5"
        :class="activeDashRoute"
        active-class="mactive"
        :to="{ name: 'orgdashboardhome' }"
      >
        <!-- <img src="@/assets/category.png" class="mr-3 icon-img"> -->
        <span class="mt-1">Dashboard</span>
      </b-link>

      <b-link
        class="dashlink"
        active-class="active"
        @click="showdl1 = !showdl1"
      >
        <!-- <img src="@/assets/schedule.png" class="mr-3 icon-img"> -->
        <span class="mt-2 link-flex-1">Test Groups</span>
        <b-icon-caret-down-fill
          v-if="showdl1 == false"
          class="mt-2 link-flex-2"
          font-scale="1"
        ></b-icon-caret-down-fill>
        <b-icon-caret-left-fill
          v-if="showdl1 == true"
          class="mt-2 link-flex-2"
          font-scale="1"
        ></b-icon-caret-left-fill>
      </b-link>
      <div class="dropdown-links" v-if="showdl1">
        <b-link
          class="dashlink-en"
          active-class="active"
          :to="{ name: 'addtestgroup' }"
          >Create Testgroups</b-link
        >
        <b-link
          class="dashlink-en"
          active-class="active"
          :to="{ name: 'listtestgroups' }"
          >All Testgroups</b-link
        >
      </div>

      <b-link
        class="dashlink"
        active-class="active"
        @click="showdl3 = !showdl3"
      >
        <!-- <img src="@/assets/schedule.png" class="mr-3 icon-img"> -->
        <span class="mt-2 link-flex-1">Test Questions</span>
        <b-icon-caret-down-fill
          v-if="showdl3 == false"
          class="mt-2 link-flex-2"
          font-scale="1"
        ></b-icon-caret-down-fill>
        <b-icon-caret-left-fill
          v-if="showdl3 == true"
          class="mt-2 link-flex-2"
          font-scale="1"
        ></b-icon-caret-left-fill>
      </b-link>
      <div class="dropdown-links" v-if="showdl3">
        <b-link
          class="dashlink-en"
          active-class="active"
          :to="{ name: 'uploadquestionsorg' }"
          >Upload Question</b-link
        >
        <b-link
          class="dashlink-en"
          active-class="active"
          :to="{ name: 'listquestionsorg' }"
          >All Uploaded Questions</b-link
        >
      </div>

      <b-link
        class="dashlink"
        active-class="active"
        @click="showdl2 = !showdl2"
      >
        <!-- <img src="@/assets/schedule.png" class="mr-3 icon-img"> -->
        <span class="mt-2 link-flex-1">Testspaces</span>
        <b-icon-caret-down-fill
          v-if="showdl2 == false"
          class="mt-2 link-flex-2"
          font-scale="1"
        ></b-icon-caret-down-fill>
        <b-icon-caret-left-fill
          v-if="showdl2 == true"
          class="mt-2 link-flex-2"
          font-scale="1"
        ></b-icon-caret-left-fill>
      </b-link>
      <div class="dropdown-links" v-if="showdl2">
        <b-link
          class="dashlink-en"
          active-class="active"
          :to="{ name: 'createtestspacesorg' }"
          >Create Testspace</b-link
        >
        <b-link
          class="dashlink-en"
          active-class="active"
          :to="{ name: 'listtestspacesorg' }"
          >All Your Testspaces</b-link
        >
      </div>

      <b-link
        class="dashlink"
        :to="{ name: 'candiatesandgroupsorg' }"
        :class="activeRoute2"
        active-class="active"
      >
        <!-- <img src="@/assets/profile.png" class="mr-3 icon-img"> -->
        <!-- <b-icon-plus-circle class="mr-3 mt-1" font-scale="1.5"></b-icon-plus-circle> -->
        <span class="mt-2">Candidates and Groups</span>
      </b-link>

      <b-link
        class="dashlink"
        active-class="active"
        :to="{ name: 'SubscriptionsViewOrg' }"
      >
        <!-- <b-icon-credit-card-fill class="mr-3 mt-1" font-scale="1.5"></b-icon-credit-card-fill> -->
        <span class="mt-2">Subscription & Plan</span>
      </b-link>

      <b-link
        :to="{ name: 'SettingsOrg' }"
        class="dashlink"
        active-class="active"
      >
        <span class="mt-1">Settings and Configurations</span>
      </b-link>

      <b-link
        class="dashlink"
        active-class="active"
        :to="{ name: 'ProfileViewOrg' }"
      >
        <!-- <img src="@/assets/profile.png" class="mr-3 icon-img"> -->
        <span class="mt-2">User & Organization Profile</span>
      </b-link>

      <b-link class="dashlink" active-class="active" @click="confirmLogout()">
        <!-- <img src="@/assets/logout.png" class="mr-3 icon-img"> -->
        <span class="mt-2">Logout</span>
      </b-link>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
  props: ["navbody"],
  // watch : {
  //     $route(){
  //         this.activeRoute
  //     }
  // },
  data() {
    return {
      currentbase: "",
      showdl1: false,
      showdl2: false,
      showdl3: false
    };
  },
  watch: {
    $route() {
      this.activeRoute;
    }
  },
  methods: {
    ...mapActions(["logOut"]),
    confirmLogout() {
      this.$bvModal.show("modal-logout");
    },
    loggingOut() {
      let now = new Date();
      now.setFullYear(now.getFullYear() - 20);
      document.cookie = `remember=;expires=${now.toUTCString()}`;
      document.cookie = `qid=;expires=${now.toUTCString()}`;
      this.logOut().then(() => {
        this.$router.push({
          name: "login"
        });
      });
    },
    hide2nd() {
      this.$bvModal.hide("modal-logout");
    }
  },
  computed: {
    ...mapState({
      details: state => state.loginmaster.details,
      orgspaces: state => state.dashboard.allorgspaces
    }),
    activeRoute() {
      let matchArray = this.$route.matched.findIndex(x => x.name == "results");
      // this.currentbase = 'results'
      //console.log(matchArray)
      return matchArray != -1 ? "active" : "inactive";
    },
    activeRoute2() {
      let matchArray = this.$route.matched.findIndex(x => x.name == "spaces");
      //console.log(matchArray)
      // this.currentbase = 'spaces'
      return matchArray != -1 ? "active" : "inactive";
    },

    activeDashRoute() {
      let matchArray = this.$route.matched.findIndex(x => x.name == "dashhome");
      //console.log(matchArray)
      return matchArray != -1 ? "active" : "inactive";
    },
    badgeVariant() {
      let matchArray = this.$route.matched.findIndex(x => x.name == "spaces");
      //console.log(matchArray)
      return matchArray != -1 ? "light" : "dark";
    }
  }
};
</script>

<style scoped>
.dashbody {
  background-color: #3a477c;
  height: 100vh;
}
.dashtext {
  font-size: 18px;
  font-family: "Times New Roman", Times, serif;
  color: white;
}

/*.dashlink {
  display: flex;
  font-size: 16px;
  margin-top: 1rem;
  text-decoration: none;
  color: black;
  padding: 3px;
  border-bottom: 1px solid rgba(237, 228, 228, 0.412)
}*/
.dashlink {
  display: flex;
  font-size: 0.9rem;
  margin-top: 0.2rem;
  text-decoration: none;
  color: white;
  padding: 0.8rem;
  border-radius: 10px 10px;
  border-bottom: 1px solid rgba(237, 228, 228, 0.412);
}
.dashlink:hover {
  background-color: #3a477c;
}
.dashlink-en {
  display: block;
  font-size: 0.9rem;
  margin-top: 0.2rem;
  text-decoration: none;
  color: white;
  padding: 0.8rem;
  padding-left: 1.3rem;
}
.dashlink-en:hover {
  background-color: #3a477c;
}
.dropdown-links {
  background-color: #263056;
  border-radius: 10px 10px;
}
.link-flex-1 {
  width: 90%;
}
.link-flex-2 {
  width: 10%;
}

.active {
  border-right: 14px solid #263056;
  color: #3357ea;
}
.mactive {
  color: gray;
  border-right: 15px solid rgba(242, 20, 20, 0.808);
}

.logo-wrapper {
  padding: 10px;
  width: 100%;
  display: flex;
  gap: 20px;
  color: #263056;
  font-weight: bold;
  font-size: 24px;
  margin-top: -15px;
  max-height: 80px;
  overflow-y: hidden;
}

.dash-logo {
  height: 60px;
  width: 60px;
}

@media screen and (min-width: 999px) {
  .sbb {
    display: none;
  }
}

@media (max-width: 999px) {
  .navbody {
    background: #263056;
  }

  .logo-wrapper {
    margin-top: 10px;
  }
}
</style>
